<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key" :status="item.status"></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import legaltextsMain from "@/pages/inquiry/legaltexts-main"
export default {
  components: {
    legaltextsMain
  },
  name: "legaltexts",
  data() {
    return {
      tabData: [
        {
          name: "全部",
          key: "legaltextsAll",
          comp: legaltextsMain,
          status: "",
        },
        {
          name: "待签署",
          key: "legaltextsNone",
          comp: legaltextsMain,
          status: "0"
        },
        {
          name: "已签署",
          key: "legaltextsHas",
          comp: legaltextsMain,
          status: "1"
        }
      ],
      tabCur: "legaltextsAll"
    }
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"

    })
  },
  created() {
  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
};
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/inquiry/legaltexts.vue